export class FlatMediaModel {
  constructor(
    public id: number = null,
    public label: string = null,
    public idParent: number = null,
    public highlight = false,
    public disabled = false
  ) {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
